var params = (new URL(document.location)).searchParams;
const hookUrl = params.get('hook_url') || params.get('HOOK_URL');
console.log("Hook_URL: " +hookUrl);

  $.get("https://cloud.punchoutexpress.com/gateway/ba9b9bb0?username=sap-buyer-id&password=12d46b0dab12384b853731f39b7eaab8&hook_url=" + encodeURIComponent(hookUrl),function(data) {
  var myregexp = /(https:\/\/.+?)"/;
var match = myregexp.exec(data);
if (match != null) {
	result = match[1];
  location.href=result;
} else {
	result = "";
}
});

//location.href="https://cloud.punchoutexpress.com/gateway/ba9b9bb0?username=sap-buyer-id&password=12d46b0dab12384b853731f39b7eaab8&hook_url=" + encodeURIComponent(hookUrl);
